import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import { string, oneOfType, object, func } from 'prop-types'
import styled from 'styled-components'

import { useNavContext } from '../../contexts/NavContext'
import { Button } from '../Button'

export const StyledNavButton = styled(Button)``

export const NavItem = forwardRef(({ ariaLabel, as, children, onClick, ...rest }, ref) => {
  const localRef = useRef()
  useImperativeHandle(ref, () => localRef.current)

  const { menuVisible, toggleMenu } = useNavContext()

  const onButtonClick = () => {
    if (menuVisible) toggleMenu()
    if (onClick) {
      onClick()
    }
  }

  return (
    <div>
      <StyledNavButton
        forwardedAs={as}
        size='small'
        ariaLabel={ariaLabel}
        onClick={onButtonClick}
        {...rest}
      >
        {children}
      </StyledNavButton>
    </div>
  )
})

NavItem.propTypes = {
  ariaLabel: string.isRequired,
  as: oneOfType([object, string]),
  children: oneOfType([object, string]),
  onClick: func,
}

NavItem.defaultProps = {
  as: 'a',
}
